import useScrollLock from '@/hooks/useScrollLock';
import { useDarkMode } from '@/hooks/useDarkMode';

import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
export default function ConfirmModal({ isOpen, onClose, onConfirm, title, message, confirmText = "Delete", confirmStyle = "danger" }) {
  const darkMode = useDarkMode();
  useScrollLock(isOpen);
  
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{
        background: darkMode.isDark ? 'rgba(0, 0, 0, 0.85)' : 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 99999,
        pointerEvents: 'auto'
      }}
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-md rounded-2xl shadow-2xl p-6 transition-colors"
        style={{ 
          background: darkMode.bgSecondary,
          pointerEvents: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-4 mb-6">
          <div 
            className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center"
            style={{ background: confirmStyle === "danger" ? '#FEE2E2' : '#FED7A5' }}
          >
            <AlertTriangle 
              className="w-6 h-6" 
              style={{ color: confirmStyle === "danger" ? '#EF4444' : '#9E6752' }} 
            />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold mb-2 transition-colors" style={{ color: darkMode.textPrimary }}>
              {title}
            </h3>
            <p className="text-sm leading-relaxed transition-colors" style={{ color: darkMode.textSecondary }}>
              {message}
            </p>
          </div>
        </div>

        <div className="flex gap-3">
          <Button
            onClick={onClose}
            variant="outline"
            className="flex-1 transition-colors"
            style={{ 
              borderColor: darkMode.borderPrimary, 
              color: darkMode.textSecondary,
              background: darkMode.bgPrimary
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="flex-1"
            style={{ 
              background: confirmStyle === "danger" ? '#EF4444' : '#9E6752', 
              color: 'white' 
            }}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
}
